import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { OrderMonitorReducer } from './reducer';
import { OrderMonitorEffects } from './effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('orderMonitor', OrderMonitorReducer),
    EffectsModule.forFeature([OrderMonitorEffects])
  ],
  providers: [OrderMonitorEffects]
})
export class OrderMonitorStoreModule { }
